import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/UserLogin.vue'
import Register from '@/views/UserRegister.vue'
import DashBoard from '@/views/DashBoard.vue'

// 学员功能组件
import Reservation from '@/views/student/ReserVation.vue'
import MyReservations from '@/views/student/MyReservations.vue'
import Progress from '@/views/student/ProgRess.vue'

// 教练功能组件
import Schedule from '@/views/coach/ScheDule.vue'
import StudentManagement from '@/views/coach/StudentManagement.vue'
import CoachReservations from '@/views/coach/CoachReservations.vue'

// 管理员功能组件
import UserManagement from '@/views/admin/UserManagement.vue'
import CoachManagement from '@/views/admin/CoachManagement.vue'
import SystemSettings from '@/views/admin/SystemSettings.vue'
import PersonalCenter from "@/views/PersonalCenter.vue";
import store from "@/store";

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/login', component: Login },
    { path: '/register', component: Register },
    {
      path: '/personal-center',
      name: 'personalCenter',  // 添加name属性
      component: PersonalCenter,
      meta: { requiresAuth: true }  // 需要认证
    },
    {
      path: '/dashboard',
      component: DashBoard,
      meta: { requiresAuth: true },
      redirect: '/dashboard/welcome',
      children: [
        // 欢迎页面
        {
          path: 'welcome',
          name: 'welcome',
          component: {
            template: '<div>欢迎页面 - 请选择左侧菜单</div>'
          }
        },

        // 学员路由
        { path: 'reservation', name: 'reservation', component: Reservation },
        { path: 'my-reservations', name: 'myReservations', component: MyReservations },
        { path: 'progress', name: 'progress', component: Progress },

        // 教练路由
        { path: 'schedule', name: 'schedule', component: Schedule },
        { path: 'student-management', name: 'studentManagement', component: StudentManagement },
        { path: 'coach-reservations', name: 'coachReservations', component: CoachReservations },

        // 管理员路由
        { path: 'user-management', name: 'userManagement', component: UserManagement },
        { path: 'coach-management', name: 'coachManagement', component: CoachManagement },
        { path: 'system-settings', name: 'systemSettings', component: SystemSettings },

      ]
    }
  ]
})

// 更新路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userInfoStr = localStorage.getItem('userInfo')
  let userInfo = {}

  try {
    userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
  } catch (error) {
    console.error('解析用户信息失败:', error)
  }

  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // 没有token，跳转到登录页
      next('/login')
      return
    }

    // 个人中心对所有认证用户开放，跳过角色检查
    if (to.name === 'personalCenter') {
      next()
      return
    }

    // 检查角色权限（仅对dashboard子路由）
    const userRole = userInfo.role ? userInfo.role.toLowerCase() : ''

    // 学员只能访问学员功能
    if (userRole === 'student') {
      const studentRoutes = ['reservation', 'myReservations', 'progress', 'welcome']
      if (!studentRoutes.includes(to.name)) {
        next('/dashboard/welcome')
        return
      }
    }

    // 教练只能访问教练功能
    if (userRole === 'coach') {
      const coachRoutes = ['schedule', 'studentManagement', 'coachReservations', 'welcome']
      if (!coachRoutes.includes(to.name)) {
        next('/dashboard/welcome')
        return
      }
    }

    // 管理员只能访问管理功能
    if (userRole === 'admin') {
      const adminRoutes = ['userManagement', 'coachManagement', 'systemSettings', 'welcome']
      if (!adminRoutes.includes(to.name)) {
        next('/dashboard/welcome')
        return
      }
    }
  }

  // 如果有认证警告，但用户仍然可以继续访问
  const hasAuthWarning = store.getters.hasAuthWarning
  if (hasAuthWarning) {
    console.log('有认证警告，但允许继续访问:', to.path)
  }

  next()
})

export default router
